import { render, staticRenderFns } from "./attachments-list-modal.vue?vue&type=template&id=6c270584&scoped=true&"
import script from "./attachments-list-modal.vue?vue&type=script&lang=js&"
export * from "./attachments-list-modal.vue?vue&type=script&lang=js&"
import style0 from "./attachments-list-modal.vue?vue&type=style&index=0&id=6c270584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c270584",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
